import { render, staticRenderFns } from "./CollectionSamplesMap.vue?vue&type=template&id=58013ed0&"
import script from "./CollectionSamplesMap.vue?vue&type=script&lang=js&"
export * from "./CollectionSamplesMap.vue?vue&type=script&lang=js&"
import style0 from "./CollectionSamplesMap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports